// extracted by mini-css-extract-plugin
module.exports = {"addressItem":"contractSimplified_addressItem__HH3MZ","addressSection":"contractSimplified_addressSection__2rxek"};